import { useMemo } from "react";
import { useQuery } from "./useQuery";

const useResponses = () => {
  const { query, actions: queryAction } = useQuery();
  const responseIds = useMemo(
    () =>
      (query && query.report && query.report.resultset.map((r) => r.id)) || [],
    [query]
  );
  const actions = useMemo(
    () => ({
      note: queryAction.note,
      response: queryAction.response,
      download: queryAction.download,
    }),
    [queryAction]
  );
  return { responseIds, actions };
};

export { useResponses };
